import { CSSProperties, FC, ReactNode } from 'react';
import { TOKENS } from './tokens';

type Variant = 'default' | 'hero';

type Props = {
  children: ReactNode;
  variant?: Variant;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  accentBar?: string;
};

// Standard surface for any card-shaped content in the redesigned UI.
// Replaces ad-hoc `card card-flush ...` Metronic markup with a single,
// tokenized component so all cards share the same border, radius, padding,
// shadow.
export const PageCard: FC<Props> = ({
  children,
  variant = 'default',
  className,
  style,
  onClick,
  accentBar,
}) => {
  const radius = variant === 'hero' ? TOKENS.radius.hero : TOKENS.radius.card;
  const padding = variant === 'hero' ? TOKENS.spacing.lg : `${TOKENS.spacing.md}px ${TOKENS.spacing.lg}px`;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: TOKENS.color.card,
        border: `1px solid ${TOKENS.color.border}`,
        borderLeft: accentBar ? `4px solid ${accentBar}` : undefined,
        borderRadius: radius,
        padding: typeof padding === 'number' ? `${padding}px` : padding,
        boxShadow: TOKENS.shadow.card,
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
